module.exports = __webpack_public_path__ + "static/birdie-1ce8dc214a4718232b3ea3ff6206daa2.png";